/**
 * A Redux store provider-wrapped component for the Assignment modal launcher
 */

import * as React from "react";

import type {Assignment, DCULPath} from "@khan/assignments-types";
import {StoreProvider} from "@khan/class-store";

import AssignmentModalLauncher from "./assignment-modal-launcher.tsx";

interface Props {
    contentDescriptor: string;
    contentPath?: DCULPath;
    initialAssignment?: Assignment;
    subjectSlug: string;
    onClose?: () => unknown;
    onSubmit?: () => unknown;
    onSuccess?: () => unknown;
}

const CreateAssignmentModalStoreProvider = ({
    contentDescriptor,
    contentPath,
    initialAssignment,
    subjectSlug,
    onClose,
    onSubmit,
    onSuccess,
}: Props): React.ReactElement => {
    return (
        <StoreProvider>
            {/* This needs to be wrapped with StoreProvider since this
            is async loaded in assignments-async-loader-package.js
            */}
            <AssignmentModalLauncher
                contentDescriptor={contentDescriptor}
                contentPath={contentPath}
                initialAssignment={initialAssignment}
                subjectSlug={subjectSlug}
                onClose={onClose}
                onSubmit={onSubmit}
                onSuccess={onSuccess}
            />
        </StoreProvider>
    );
};

export default CreateAssignmentModalStoreProvider;
